import React from "react";

function Contact() {
  return (
    <div className="container container-sm">
      <section>
        <h1>Kontakt</h1>
        <p>
          <strong>meZWEI medizin- und medien-privatinstitut GmbH</strong>
          <br />
          Breite Straße 40
          <br />
          55124 Mainz
        </p>
        <p>
          Telefon 0049 6131 49987-0
          <br />
          Fax 0049 6131 49987-10
          <br />
          info@mezwei.de
        </p>
      </section>
    </div>
  );
}

export default Contact;
